import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import {Table, Drawer, Button, Input, Row, Col, Spin, Tooltip, Modal, Popconfirm, Switch} from 'antd';
import QrForm from './../components/qr.form';
import Config from './../config';

export default class QrTable extends React.Component {

    static defaultProps = {
        page: 0,
        total: 0,
        limit: 0,
        list: [],
        loading: false,
        form_loading: false,
        updateFilter: () => {
        },
        updateSort: () => {
        },
        updatePage: () => {
        },
        onUpdate: () => {
        },
        onDelete: () => {
        },
        onCreate: () => {
        },
    };

    static propTypes = {
        page: PropTypes.number.isRequired,
        total: PropTypes.number.isRequired,
        limit: PropTypes.number.isRequired,
        list: PropTypes.arrayOf(Object).isRequired,
        loading: PropTypes.bool.isRequired,
    };


    Columns = [
        {
            'title': "Name",
            'dataIndex': 'name',
            'render': t => {
                return t.length < 20 ? t :
                    <Tooltip title={t}><span className={"link"}>{`${t.substr(0, 17)}...`}</span></Tooltip>;
            }
        },
        {
            'title': 'Note',
            'dataIndex': 'note',
            'render': t => {
                if (!t) return '';
                return t.length < 20 ? t :
                    <Tooltip title={t}><span className={"link"}>{`${t.substr(0, 17)}...`}</span></Tooltip>;
            }
        },
        {
            'title': 'Link',
            'dataIndex': 'original_url',
            'render': t => {
                return <a href={t} target={"_blank"} rel={"nofollow"}>{t.length > 30 ? `${t.substr(0, 27)}...` : t}</a>
            }
        },
        {
            'title': 'QR',
            'key': 'qr',
            'render': row => {
                return <Button type={`primary`} onClick={() => this.openModal(row)}
                               icon={`qrcode`}>{row.qr_file.length > 20 ? `${row.qr_file.substr(0, 17)}...` : row.qr_file}</Button>
            }
        },
        {
            'title': 'Created at',
            'key': 'created_at',
            render: t => Moment(t.createdAt).format('LLL')
        },
        {
            'title': 'Owner',
            'key': 'owner',
            'render': r => {
                if (r && r.owner_id) {
                    return r.owner_id && r.owner_id.email ? r.owner_id.email : '[unknown]';
                }
                return `[unknown]`;
            },
        },
        {
            'title': 'Total redirects',
            'dataIndex': 'total',
            'align': 'center',
        },
        {
            'title': 'Active',
            'key': 'active',
            'render': row => {
                return <Switch defaultChecked={row.active} onChange={(active) => this.props.onUpdate(row.id, { active })}/>
            },
        },
        {
            'title': 'Actions',
            'key': 'actions',
            'render': row => {
                return (
                    <React.Fragment>
                        <div className="actions">
                            <Button type={`primary`} icon={`edit`} onClick={() => this.showDrawer(row)}/>
                            <Popconfirm title="Are you sure delete this qr?" onConfirm={() => this.props.onDelete(row.id)}>
                                <Button type={`danger`} icon={`delete`} />
                            </Popconfirm>

                        </div>
                    </React.Fragment>
                );
            }
        }
    ];

    state = {
        drawer: false,
        modal: false,
        item: {},
    };

    openModal = (item) => {
        this.setState({modal: true, item});
    };

    hideModal = () => {
        this.setState({modal: false, item: {}});
    };

    showDrawer = (item = {}) => {
        this.setState({drawer: true, item});
    };

    hideDrawer = () => {
        this.setState({drawer: false, item: {}});
    };

    onSubmit = (data = {}) => {
        if (this.state.item && this.state.item.id) {
            this.hideDrawer();
            this.props.onUpdate(this.state.item.id, data);
        } else {
            this.hideDrawer();
            this.props.onCreate(data);
        }
    };

    render() {
        return (
            <React.Fragment>
                <Modal title={`QR preview`} visible={this.state.modal}
                       footer={[<Button type="primary" onClick={this.hideModal}>Cancel</Button>]}
                       onCancel={this.hideModal} width={520}>
                    <p>Filename: {this.state.item.qr_file}</p>
                    <img src={`${Config.STATIC_FILES}/${this.state.item.qr_file}`} alt={this.state.item.qr_file}
                         className={`qr_code`}/>
                </Modal>
                <Drawer
                    title={this.state.item && this.state.item.id ? `Update qr code` : `Create qr code`}
                    width={520}
                    placementh={`right`}
                    visible={this.state.drawer}
                    onClose={this.hideDrawer}
                >
                    <Spin spinning={this.props.form_loading}>
                        {this.state.drawer && (<QrForm
                            item={this.state.item}
                            onSubmit={this.onSubmit}
                        />)}
                    </Spin>
                </Drawer>
                <Table
                    bordered
                    title={() =>
                        <React.Fragment>
                            <Row>
                                <Col span={3}>
                                    <Button type={`primary`} onClick={this.showDrawer}>Create</Button>
                                </Col>
                                <Col span={21}>
                                    <Input.Search placeholder={`Enter title or link`} enterButton={'Search'} onSearch={(t) => this.props.updateFilter(t)}/>
                                </Col>
                            </Row>
                        </React.Fragment>
                    }
                    loading={this.props.loading}
                    columns={this.Columns}
                    dataSource={this.props.list}
                    rowKey={(item) => item.id}
                    pagination={{
                        pageSize: this.props.limit,
                        defaultCurrent: this.props.page,
                        total: this.props.total,
                        onChange: this.props.updatePage,
                        current: this.props.page,
                    }}
                />
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/qr.table.js